// 导入历史记录相关的API服务
import api from '@/api/api.js'

// 导入历史相关API接口
const importHistoryAPI = {
  // 导出历史记录分页查询
  // 请求参数: {operateorName: string, startTime: string, endTime: string, fileName: string, pageSize: string, pageNo: string}
  // 返回格式: {code: number, msg: string, data: {pageSize: string, pageNo: string, count: string, data: [...]}}
  getImportHistory: (params) => {
    return api.post('/history-record/page', params)
  },
  
  // 下载导入文件
  downloadImportFile: async (id) => {
    // 参数验证
    if (!id || id === undefined || id === null) {
      throw new Error('缺少必需参数: id')
    }
    
    // 使用arraybuffer类型以便更好地处理可能的JSON错误响应
    const response = await api.get('/history-record/download-file', { 
      responseType: 'arraybuffer',
      params: { id } 
    })
    
    // 获取响应头中的content-type
    const contentType = response.headers.get('content-type') || ''
    
    // 优先检查content-type，如果明确不是JSON，则直接处理为文件
    if (!contentType.includes('application/json')) {
      // 不是JSON，直接作为文件处理
      if (!response.data || response.data.byteLength === 0) {
        throw new Error('下载的文件为空')
      }
      
      return new Blob([response.data])
    }
    
    // 如果content-type是JSON，尝试解析
    try {
      const jsonString = new TextDecoder('utf-8').decode(response.data)
      const jsonData = JSON.parse(jsonString)
      
      // 如果成功解析为JSON且包含code字段
      if (jsonData && typeof jsonData.code === 'number') {
        if (jsonData.code !== 0) {
          // 业务码不为0，抛出错误
          throw new Error(jsonData.msg || '文件下载失败')
        }
      }
    } catch (error) {
      // 如果JSON解析失败，但响应数据不为空，可能是正常的文件数据
      // 特别处理常见的二进制文件标志（如ZIP文件的'PK'头）
      if (error instanceof SyntaxError && response.data && response.data.byteLength > 0) {
        console.debug('JSON解析失败，但响应包含数据，视为文件下载')
        // 直接返回文件数据
        return new Blob([response.data])
      }
      // 其他错误则向上抛出
      throw error;
    }
    
    // 检查是否是有效的文件数据
    if (!response.data || response.data.byteLength === 0) {
      throw new Error('下载的文件为空')
    }
    
    // 转换为Blob对象并返回
    return new Blob([response.data])
  },
  
  // 导出Excel - 与证书导出保持一致的实现
  exportExcel: async (params) => {
    const response = await api.post('/history-record/export-excel', params, { responseType: 'arraybuffer' })
    
    // 获取响应头中的content-type
    const contentType = response.headers.get('content-type') || ''
    
    // 检查是否包含JSON格式的错误响应
    if (contentType.includes('application/json')) {
      // 尝试解析为JSON
      const jsonString = new TextDecoder('utf-8').decode(response.data)
      const jsonData = JSON.parse(jsonString)
      
      // 如果解析成功且包含code字段
      if (jsonData && typeof jsonData.code === 'number') {
        if (jsonData.code !== 0) {
          // 业务码不为0，抛出错误
          throw new Error(jsonData.msg || '导出失败')
        }
      }
    }
    
    // 检查是否是有效的文件数据
    if (!response.data || response.data.byteLength === 0) {
      throw new Error('导出的文件为空')
    }
    
    // 转换为Blob并返回
    return new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  }
}

// 导出API
export default importHistoryAPI